module.exports = __webpack_public_path__ + "static/img/otzarhahayal.43b2140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/otzarhahayal.jpg
// module id = k5Q3
// module chunks = 6